module.exports = __webpack_public_path__ + "img/bondora.6306cc8.png";